import { createContext, Dispatch, SetStateAction } from "react";
// import { Assignment } from "./types";

interface CurrentAssignmentContextType {
  currentAssignment: any | null;
  setCurrentAssignment: Dispatch<SetStateAction<any | null>>;
}

const CurrentAssignmentContext = createContext<CurrentAssignmentContextType>({
  currentAssignment: null,
  setCurrentAssignment: () => null,
});

export default CurrentAssignmentContext;
